import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {DatePipe} from '@angular/common';
import {TaskService} from '../../services/task.service';
import {NzModalRef, NzModalService} from 'ng-zorro-antd/modal';
import {NzMessageService} from 'ng-zorro-antd/message';
import {BehaviorSubject, Observable} from 'rxjs';
import {debounceTime, map, switchMap} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {UtilsModule} from '../../utils/utils.module';

const dayMs = 86400000;

@Component({
  selector: 'task-new-calendar',
  templateUrl: './new-calendar.component.html',
  styleUrls: ['./new-calendar.component.css'],
  providers: [DatePipe]
})
export class NewCalendarComponent implements OnInit {

  date = new Date(); // 时间
  dateDisplay; // 时间展示文本
  weekDayDisplay;
  dayList = []; // 日期列表
  dayListIndex = {};
  boardId = null; // 存放面板ID
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardColumnData: Array<any> = []; // 面板表头数据
  boardPulseData: Array<any> = []; // 面板列表数据
  currentUser;
  calendarEvent = []; // 存放日历事件
  otherEvent = []; // 存放除日历事件外的其他事件
  eventsList = []; // 存放日历视图中的列表
  eventHeight = []; // 存放每行的高度
  groupMap = {};
  nameId = '';
  defaultStatus: any = {}; // 状态下拉颜色

  calendarType = 'month';
  dateColumns = []; // 所有日期列（包括日期时间）
  dateColumn = {}; // 当前选择的日期列
  userColumns = []; // 所有人员列
  userColumn: any = {}; // 当前选择的人员列
  menuFold = false; // 右侧任务列表折叠状态，默认展开
  userPopVisible = false;
  popVisible = false;
  otherContentHeight = '';
  randomUserUrl: string;
  searchChange$ = new BehaviorSubject('');
  group: any = {}; // 当前组件分组数据
  pulse: any = {}; // 当前组件行数据
  column: any = {}; // 当前组件列数据
  personOption: Array<any> = [];  // 指派人组件下拉选项
  selectedPulseId = '';
  selectedGroup = '';
  addPulseNameValue = ''; // 添加行输入框绑定值
  addTaskData: any = {}; // 存放新增任务数据
  isLoading = false;
  statusWidth = 135; // 标签组件下拉框动态宽度
  isEditVisual = true; // 标签组件下拉框按钮状态
  statusInit = []; // 存放初始状态色块
  statusTemp = []; // 存放操作过程中状态
  statusDel = []; // 存放移除掉的状态;
  addTabBGColor = '#F7F7F7'; // 添加标签默认背景颜色
  addProgressValue = 0; // 存放进度条
  clickButtonLoading: boolean;
  buttonConfigEditData = {};
  buttonConfigStatus = true;
  buttonConfigEditStatus = false;
  buttonConfigTitle = '';
  buttonConfigDisabled = true;
  buttonConfigUrl = '';
  containerWidth;
  userColorMap = new Map();
  @Input('nfData') set nfDataChange(data) {
    if (data && JSON.stringify(data) !== '{}') {
      this.boardData = data;
      this.boardId = this.boardData.id;
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
      this.currentUser = this.boardData.boardData.currentUser;
      if (!this.currentUser) {
        this.currentUser = {};
      }
      if (this.boardData.boardData.users) {
        for (const item of this.boardData.boardData.users) {
          this.userColorMap.set(item.id, this.utilsModule.getRandomColor());
        }
      }
      this.generateGroupMap();
      this.handleColumn();
      this.getCalendarEvent();
      this.handleTask();
    }
  }
  @ViewChild('modalTplContent', { static: true }) modalTplContent: any;
  @ViewChild('chooseGroupContent', {static: true}) chooseGroupContent;
  @ViewChild('tplFooter', { static: true }) tplFooter: any;
  tplModal: NzModalRef;
  constructor(
    private datePipe: DatePipe,
    private taskService: TaskService,
    private modalService: NzModalService,
    private message: NzMessageService,
    private utilsModule: UtilsModule,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    this.dateDisplay = this.datePipe.transform(this.date, 'yyyy 年 M 月');
    this.statusInit = JSON.parse(localStorage.getItem('statusInit'));
    this.statusWidth = this.statusInit.length / 4 * 122;
    this.otherContentHeight = window.innerHeight - 340 + 'px';
    const container = document.getElementById('container');
    if (container) {
      this.containerWidth = (container.clientWidth || container.offsetWidth) - 400 + 'px';
    } else {
      this.containerWidth = window.innerWidth - 630 + 'px';
    }
    this.generateMonthList();
  }

  pre() {
    if (this.calendarType === 'month') {
      this.preMonth();
    } else if (this.calendarType === 'week') {
      this.preWeek();
    } else {
      this.preDate();
    }
  }
  next() {
    if (this.calendarType === 'month') {
      this.nextMonth();
    } else if (this.calendarType === 'week') {
      this.nextWeek();
    } else {
      this.nextDate();
    }
  }
  preMonth() {
    const month = this.date.getMonth();
    if (month === 0) {
      this.date.setFullYear(this.date.getFullYear() - 1);
      this.date.setMonth(11);
    } else {
      this.date.setMonth(month - 1);
    }
    this.generateMonthList();
  }
  nextMonth() {
    const month = this.date.getMonth();
    if (month === 11) {
      this.date.setFullYear(this.date.getFullYear() + 1);
      this.date.setMonth(0);
    } else {
      this.date.setMonth(month + 1);
    }
    this.generateMonthList();
  }
  preWeek() {
    this.date = new Date(this.date.valueOf() - 7 * dayMs);
    this.generateWeekList();
  }
  nextWeek() {
    this.date = new Date(this.date.valueOf() + 7 * dayMs);
    this.generateWeekList();
  }
  preDate() {
    this.date.setDate(this.date.getDate() - 1);
    this.generateDayList();
  }
  nextDate() {
    this.date.setDate(this.date.getDate() + 1);
    this.generateDayList();
  }
  backToToday() {
    this.date = new Date();
    if (this.calendarType === 'month') {
      this.generateMonthList();
    } else if (this.calendarType === 'week') {
      this.generateWeekList();
    } else {
      this.generateDayList();
    }
  }
  calendarTypeChange() {
    if (this.calendarType === 'month') {
      this.generateMonthList();
    } else if (this.calendarType === 'week') {
      this.generateWeekList();
    } else {
      this.generateDayList();
    }
  }
  // 生成日历列表
  generateMonthList() {
    this.dateDisplay = this.datePipe.transform(this.date, 'yyyy 年 M 月');
    const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    const year = this.date.getFullYear();
    const month = this.date.getMonth();
    let res;
    const currentMonth = this.getMonthCount(year, month); // 获取当前月的天数
    const preMonth = this.getPreMonthCount(year, month); // 获取上月天数
    const nextMonth = this.getNextMonthCount(year, month); // 获取下月天数
    let whereMonday = this.getWeekday(year, month);
    if (whereMonday === 0) { // month对应月份的1号是周日
      whereMonday = 7;
    }
    let preArr = [];
    if (whereMonday !== 1) {
      preArr = preMonth.slice(-whereMonday + 1);
    }
    let nextArr = [];
    const count = currentMonth.length + preArr.length;
    // 如果上个月天数加这个月天数小于35，截取下个月前面几天，补齐到35， 分5行展示
    // 如果刚好35天则不做操作
    // 如果大于35，还是截取下个月前面几天，补齐到42， 分6行展示
    if (count < 35) {
      nextArr = nextMonth.slice(0, 35 - count);
    } else if (count > 35) {
      nextArr = nextMonth.slice(0, 42 - count);
    }
    // 将上月、本月、下月合并在一起，总数应为35或42
    res = [].concat(preArr, currentMonth, nextArr);
    // 将日期转化为二维数组，一行7个，对应周一到周日
    const rows = res.length / 7;
    this.dayList = [];
    this.dayListIndex = {};
    for (let i = 0; i < rows; i++) {
      this.dayList.push([]);
    }
    for (let i = 0; i < res.length; i++) {
      // 将年月日写到对象中
      let m = i < preArr.length ? (month - 1) : (i < count ? month : (month + 1));
      let y = year;
      if (m === -1) {
        y -= 1;
        m = 11;
      } else if (m === 12) {
        y += 1;
        m = 0;
      }
      const currentMonth = i >= preArr.length && i < count;
      const j = Math.floor(i / 7);
      const full = this.datePipe.transform(new Date(y + '-' + (m + 1) + '-' + res[i]), 'yyyy-MM-dd');
      this.dayList[j].push({
        year: y,
        month: m,
        date: res[i],
        full: full,
        today: full === today,
        currentMonth: currentMonth
      });
      this.dayListIndex[full] = {x: j, y: (i % 7)};
    }
    this.handleTask();
  }
  // 生成周列表
  generateWeekList() {
    this.dayList = [];
    this.dayList.push([]);
    this.dayListIndex = {};
    const day = this.date.getDay(); // 当前日期是周几 [0-6] --> 周日-周六
    const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    let weekStartDate: Date; // 当前周开始的日期
    let weekEndDate: Date; // 当前周结束的日期
    if (day === 0) {
      weekStartDate = new Date(this.date.valueOf() - 6 * dayMs);
      weekEndDate = new Date(this.date.valueOf());
    } else {
      weekStartDate = new Date(this.date.valueOf() - (day - 1) * dayMs);
      weekEndDate = new Date(this.date.valueOf() + (7 - day) * dayMs);
    }
    const startMonth = weekStartDate.getMonth() + 1;
    const endMonth = weekEndDate.getMonth() + 1;
    const startDate = weekStartDate.getDate();
    const endDate = weekEndDate.getDate();
    if (startMonth === endMonth) {
      this.dateDisplay = startMonth + '月' + startDate + ' - ' + endDate;
    } else {
      this.dateDisplay = startMonth + '月' + startDate + ' - ' + endMonth + '月' + endDate;
    }
    for (let i = 0; i < 7; i++) {
      const date = new Date(weekStartDate.valueOf() + i * dayMs);
      const full = this.datePipe.transform(date, 'yyyy-MM-dd');
      this.dayList[0].push({
        year: date.getFullYear(),
        month: date.getMonth(),
        date: date.getDate(),
        full: full,
        today: full === today
      });
      this.dayListIndex[full] = {x: 0, y: i};
    }
    this.handleTask();
  }
  // 生成日列表
  generateDayList() {
    this.dayList = [];
    const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    const full = this.datePipe.transform(this.date, 'yyyy-MM-dd');
    this.dayList.push([
      {
        year: this.date.getFullYear(),
        month: this.date.getMonth(),
        date: this.date.getDate(),
        full: full,
        today: full === today
      }
    ]);
    this.dayListIndex = {};
    this.dateDisplay = this.datePipe.transform(this.date, 'yyyy年MM月dd');
    const day = this.date.getDay();
    this.weekDayDisplay = this.getWeekDay(day);
    this.dayListIndex[full] = {x: 0, y: 0};
    this.handleTask();
  }
  // 将面板任务插入到日历视图中
  handleTask() {
    this.eventsList = [];
    this.eventHeight = [];
    if (this.calendarEvent && this.dayList && this.dayList.length > 0) {
      for (let i = 0; i < this.dayList.length; i++) {
        this.eventsList.push([]);
      }
      const unit = 100 / 7; // 单位宽度
      for (const item of this.calendarEvent) {
        const date = new Date(item.date[0]);
        const dateStr = this.datePipe.transform(date, 'yyyy-MM-dd');
        let fromIndex = this.dayListIndex[dateStr]; // 记录任务从开始的位置
        let from; // 开始日期
        const to = new Date(item.date[1]); // 结束日期
        // 判断任务开始时间是否在本月
        if (fromIndex) { // 在本月
          from = date;
        } else { // 不在本月
          // 判断任务是否有在本月的时间段
          if (dateStr < this.dayList[0][0]['full'] && this.dayList[0][0]['full'] <= item.date[1]) {
            from = new Date(this.dayList[0][0]['full']);
            fromIndex = {x: 0, y: 0};
          } else {
            continue;
          }
        }
        // 计算任务持续天数
        if (this.calendarType === 'month' || this.calendarType === 'week') {
          const ms = to.valueOf() - from.valueOf();
          const days = Math.round(ms / (24 * 60 * 60 * 1000)) + 1;
          const x = fromIndex.x;
          const y = fromIndex.y;
          if (days <= (6 - y)) {
            this.eventsList[x].push({
              style: {
                width: days * unit + '%',
                left: y * unit + '%'
              },
              start: y,
              width: days,
              data: item
            });
          } else {
            this.eventsList[x].push({
              style: {
                width: (7 - y) * unit + '%',
                left: y * unit + '%'
              },
              start: y,
              width: (7 - y),
              data: item
            });
            if (this.calendarType === 'month') {
              let leftDays = days - (7 - y);
              let i = 1;
              while (leftDays > 0) {
                if (x + i < this.eventsList.length) {
                  if (leftDays > 7) {
                    this.eventsList[x + i].push({
                      style: {
                        width: '100%',
                        left: 0
                      },
                      start: 0,
                      width: 7,
                      data: item
                    });
                    leftDays = leftDays - 7;
                    i++;
                  } else {
                    this.eventsList[x + i].push({
                      style: {
                        width: leftDays * unit + '%',
                        left: 0
                      },
                      start: 0,
                      width: leftDays,
                      data: item
                    });
                    break;
                  }
                } else {
                  break;
                }
              }
            }
          }
        } else {
          this.eventsList[0].push({
            style: {
              width: '100%',
              left: 0
            },
            start: 0,
            width: 7,
            data: item
          });
        }
      }
      this.sortAndCalculatePos();
      this.handleTaskUser();
    }
  }

  sortAndCalculatePos() {
    // 排序以及计算放置位置
    for (let i = 0; i < this.eventsList.length; i++) {
      this.eventsList[i] = this.eventsList[i].sort((item1, item2) => {
        if (item1.start > item2.start) {
          return 1;
        } else if (item1.start === item2.start) {
          return item1.width > item2.width ? -1 : item1.width === item2.width ? 0 : 1;
        } else {
          return -1;
        }
      });
      this.eventHeight[i] = 158;
      // 初始化一行
      const position = [[false, false, false, false, false, false, false]];
      for (let j = 0; j < this.eventsList[i].length; j++) {
        // 标记任务是否已被计算出位置
        let flag = false;
        const event = this.eventsList[i][j];
        const pos = Array.from(new Array(event.width), () => true);
        for (let k = 0; k < position.length; k++) {
          const sub = position[k].slice(event.start, event.start + event.width);
          if (!sub.includes(true)) {
            event.style.top = k * 28 + 'px';
            const maxHeight = (k + 1) * 28 + 64;
            if (this.eventHeight[i] < maxHeight) this.eventHeight[i] = maxHeight;
            position[k].splice(event.start, event.width, ...pos);
            flag = true;
            break;
          }
        }
        if (!flag) {
          // 如果在已有行没找到可放置的位置，新开一行
          position.push([false, false, false, false, false, false, false]);
          event.style.top = (position.length - 1) * 28 + 'px';
          const maxHeight = position.length * 28 + 64;
          if (this.eventHeight[i] < maxHeight) this.eventHeight[i] = maxHeight;
          position[position.length - 1].splice(event.start, event.width, ...pos);
        }
      }
    }
  }
  // 1.判断是否为闰年
  isLeapYear(year) {
    return (year % 400 === 0) || (year % 100 !== 0 && year % 4 === 0);
  }
  // 2.获得每个月的日期有多少，注意 month - [0-11]
  getMonthCount(year, month) {
    const arr = [
      31, null, 31, 30,
      31, 30, 31, 31,
      30, 31, 30, 31
    ];
    const count = arr[month] || (this.isLeapYear(year) ? 29 : 28);
    return Array.from(new Array(count), (item, value) => value + 1);
  }
  // 3.获得某年某月的 1号 是星期几，这里要注意的是 JS 的 API-getDay() 是从 [日-六](0-6)，返回 number
  getWeekday(year, month) {
    const date = new Date(year, month, 1);
    return date.getDay();
  }
  // 4.获得上个月的天数
  getPreMonthCount(year, month) {
    if (month === 0) {
      return this.getMonthCount(year - 1, 11);
    } else {
      return this.getMonthCount(year, month - 1);
    }
  }
  // 5.获得下个月的天数
  getNextMonthCount(year, month) {
    if (month === 11) {
      return this.getMonthCount(year + 1, 0);
    } else {
      return this.getMonthCount(year, month + 1);
    }
  }
  // 6. 获取周几的中文
  getWeekDay(day) {
    let res;
    switch (day) {
      case 0:
        res = '周 日';
        break;
      case 1:
        res = '周 一';
        break;
      case 2:
        res = '周 二';
        break;
      case 3:
        res = '周 三';
        break;
      case 4:
        res = '周 四';
        break;
      case 5:
        res = '周 五';
        break;
      case 6:
        res = '周 六';
        break;
    }
    return res;
  }

  menuFoldChange() {
    this.menuFold = !this.menuFold;
  }
  // 生成group Map
  generateGroupMap() {
    this.groupMap = {};
    if (this.boardGroupData) {
      for (const group of this.boardGroupData) {
        this.groupMap[group.id] = group;
      }
    }
  }
  // 处理面板列
  handleColumn() {
    this.dateColumns = [];
    this.userColumns = [];
    if (this.boardColumnData) {
      for (const boardColumn of this.boardColumnData) {
        if (boardColumn.type === 'name') {
          this.nameId = boardColumn['id'];
        }
        if (boardColumn.type === 'status') {
          if (boardColumn) {
            this.defaultStatus[boardColumn.id] = boardColumn.labels;
          }
        }
        if (boardColumn.type === 'time-interval' || boardColumn.type === 'date-time' || boardColumn.type === 'date') {
          this.dateColumns.push(boardColumn);
        }
        if (boardColumn.type === 'multiple-person') {
          this.userColumns.push(boardColumn);
        }
      }
      if (this.dateColumns.length > 0) {
        this.dateColumn = this.dateColumns[0];
      } else {
        this.dateColumn = {};
      }
      if (this.userColumns.length > 0) {
        this.userColumn = this.userColumns[0];
      } else {
        this.userColumn = {};
      }
    }
  }

  getCalendarEvent() {
    this.calendarEvent = [];
    this.otherEvent = [];
    if (this.dateColumn && JSON.stringify(this.dateColumn) != '{}') {
      this.boardPulseData.forEach(item => {
        if (item['columnValues']) {
          const columnValue = item['columnValues'][this.dateColumn['id']];
          // 处理任务颜色
          let color = '#d2ebed';
          for (const i in this.defaultStatus) {
            if (this.defaultStatus.hasOwnProperty(i)) {
              if (item['columnValues'][i]) {
                this.defaultStatus[i].forEach(list => {
                  if (list.index === item['columnValues'][i].index) {
                    color = list.color;
                  }
                });
              }
            }
          }
          if (columnValue['date'] && columnValue['date'].length > 0) {
            const o = {
              date: columnValue.date,
              title: item.columnValues[this.nameId],
              pulseId: item.id,
              groupId: item.groupId,
              color: color,
              columnValues: item['columnValues']
            };
            // 将但日期列转换为时间区间
            if (this.dateColumn['type'] === 'date-time') {
              const dateTime = columnValue['date'] + ' ' + columnValue['time'];
              o.date = [dateTime, dateTime];
            } else if (this.dateColumn['type'] === 'date') {
              o.date = [columnValue['date'], columnValue['date']];
            }
            this.calendarEvent.push(o);
          } else {
            const o = {
              title: item.columnValues[this.nameId],
              pulseId: item.id,
              groupId: item.groupId,
              color: color,
              columnValues: item['columnValues'],
              groupColor: this.groupMap[item.groupId] ? this.groupMap[item.groupId]['color'] : ''
            };
            this.otherEvent.push(o);
          }
        }
      });
    } else {
      this.boardPulseData.forEach(item => {
        // 处理任务颜色
        let color = '#d2ebed';
        for (const i in this.defaultStatus) {
          if (this.defaultStatus.hasOwnProperty(i)) {
            if (item['columnValues'][i]) {
              this.defaultStatus[i].forEach(list => {
                if (list.index === item['columnValues'][i].index) {
                  color = list.color;
                }
              });
            }
          }
        }
        const o = {
          title: item.columnValues[this.nameId],
          pulseId: item.id,
          groupId: item.groupId,
          color: color,
          columnValues: item['columnValues'],
          groupColor: this.groupMap[item.groupId] ? this.groupMap[item.groupId]['color'] : ''
        };
        this.otherEvent.push(o);
      });
    }
  }

  addNewGroup(boardId) {
    const color = this.utilsModule.getRandomColor();
    const param = {};
    param['title'] = '新组';
    param['color'] = color;
    this.taskService.doAddGroup(boardId, param).subscribe((res: any) => {
      if (res) {
        const groupObj = {
          'title': res.title,
          'color': res.color,
          'id': res.id,
          'boardId': res.boardId
        };
        this.boardGroupData = [
          groupObj,
          ...this.boardGroupData
        ];
      }
    });
  }

  onMouseOver(target: HTMLElement, pulseId) {
    const pulses = document.getElementsByClassName(pulseId);
    if (pulses) {
      for (let i = 0; i < pulses.length; i++) {
        pulses[i].classList.add('hover');
      }
    }
  }
  onMouseLeave(target: HTMLElement, pulseId) {
    const pulses = document.getElementsByClassName(pulseId);
    if (pulses) {
      for (let i = 0; i < pulses.length; i++) {
        pulses[i].classList.remove('hover');
      }
    }
  }
  // 处理任务的人员信息
  handleTaskUser() {
    if (this.userColumn && JSON.stringify(this.userColumn) !== '{}') {
      if (this.eventsList && this.eventsList.length > 0) {
        for (const row of this.eventsList) {
          for (const item of row) {
            item['users'] = item.data.columnValues[this.userColumn['id']] ? item.data.columnValues[this.userColumn['id']]['personsAndTeams'] : [];
          }
        }
      }
    }
  }
  userColumnChange(column) {
    if (column.id !== this.userColumn.id) {
      this.userColumn = column;
      this.handleTaskUser();
    }
    this.userPopVisible = false;
  }
  columnChange(column) {
    if (column.id !== this.dateColumn['id']) {
      this.dateColumn = column;
      this.getCalendarEvent();
      this.handleTask();
    }
    this.popVisible = false;
  }
  addTaskBtnClick() {
    this.beforeAddTask({full: this.datePipe.transform(this.date, 'yyyy-MM-dd')});
  }
  beforeAddTask(day) {
    const today = new Date(day.full);
    const modal = this.modalService.create({
      nzWidth: 400,
      nzTitle: '选择任务分组',
      nzContent: this.chooseGroupContent,
      nzOkText: '确定',
      nzCancelText: '取消',
      nzOnOk: () => {
        if (this.group && JSON.stringify(this.group) !== '{}') {
          const param = {
            boardId: this.boardId,
            columnValues: {name: '新任务'},
            name: '新任务',
            groupId: this.group.id
          };
          this.taskService.doAddPulse(param).subscribe(res => {
            if (res) {
              this.pulse = res;
              this.selectedPulseId = this.pulse.id;
              this.addPulseNameValue = this.pulse.name;
              this.addTaskData = {};
              this.addTaskData[this.nameId] = this.pulse.name;
              this.selectedGroup = this.group.id;
              // 初始化新增任务字段
              this.boardColumnData.forEach((item) => {
                if (item.type === 'multiple-person') {
                  this.addTaskData[item.id] = {personsAndTeams: []};
                } else if (item.type === 'status') {
                  if (item) {
                    this.defaultStatus[item.id] = item.labels;
                  }
                  this.addTaskData[item.id] = {
                    index: 0
                  };
                } else if (item.type === 'time-interval') {
                  this.addTaskData[item.id] = {
                    date: [this.datePipe.transform(today, 'yyyy-MM-dd HH:mm'), this.datePipe.transform(today, 'yyyy-MM-dd HH:mm')]
                  };
                  this.cellValueChange(item.id, this.addTaskData[item.id]);
                } else if (item.type === 'file') {
                  this.addTaskData[item.id] = {
                    config: {
                      watermark: true,
                      watermarkContent: ''
                    },
                    files: []
                  };
                } else if (item.type === 'link') {
                  this.addTaskData[item.id] = {
                    name: '',
                    url: '',
                    params: [],
                    skipMode: '1'
                  };
                } else if (item.type === 'date') {
                  this.addTaskData[item.id] = {
                    date: this.datePipe.transform(today, 'yyyy-MM-dd')
                  };
                  this.dateChange(item.id, today);
                } else if (item.type === 'date-time') {
                  this.addTaskData[item.id] = {
                    date: this.datePipe.transform(today, 'yyyy-MM-dd'),
                    time: this.datePipe.transform(today, 'HH:mm:ss')
                  };
                  this.cellValueChange(item.id, this.addTaskData[item.id]);
                } else if (item.type === 'name') {
                  this.addTaskData[item.id] = this.pulse.name;
                } else if (item.type === 'dropdown') {
                  this.addTaskData[item.id] = {ids: []};
                } else if (item.type === 'select') {
                  this.addTaskData[item.id] = {};
                } else if (item.type === 'button') {
                  this.addTaskData[item.id] = {original: ''};
                } else {
                  this.addTaskData[item.id] = '';
                }
              });
              this.pulse.columnValues = this.addTaskData;
              this.boardPulseData.push(this.pulse);
              // 如果没有日期时间列，则将任务添加到otherEvent中
              if (JSON.stringify(this.dateColumn) === '{}') {
                const o = {
                  title: '新任务',
                  pulseId: this.selectedPulseId,
                  groupId: this.pulse.groupId,
                  groupColor: this.groupMap[this.pulse.groupId] ? this.groupMap[this.pulse.groupId]['color'] : '',
                  groupName: this.groupMap[this.pulse.groupId] ? this.groupMap[this.pulse.groupId]['title'] : '',
                  columnValues: this.addTaskData
                };
                this.otherEvent.push(o);
              } else {
                this.calendarEvent.push({
                  title: this.pulse.name,
                  pulseId: this.selectedPulseId,
                  groupId: this.selectedGroup,
                  columnValues: this.addTaskData
                });
              }
              this.addTask();
            } else {
              this.message.error('创建任务失败!');
            }
          });
        } else {
          this.message.info('请先选择分组！');
          return false;
        }
      },
      nzOnCancel: () => {
        modal.destroy();
      }
    });
  }
  // 添加任务
  addTask() {
    this.onMemberSearch('');
    this.tplModal = this.modalService.create({
      nzContent: this.modalTplContent,
      nzMaskClosable: false,
      nzTitle: null,
      nzFooter: this.tplFooter,
      nzWidth: '600px',
      nzWrapClassName: 'vertical-center-modal custom-modal'
    });
  }
  updateFilterData(id) {
  }
  getVoteData(pulse, columnId, value) {
    const param = {};
    param['pulseIds'] = [pulse.id];
    param['columnId'] = columnId;
    param['columnValue'] = {
      voters: value
    };
    this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {});
  }
  getCheck(pulse, columnId) {
    const columnValue = pulse.columnValues[columnId] !== 'true';
    const param = {};
    param['pulseIds'] = [pulse.id];
    param['columnId'] = columnId;
    param['columnValue'] = columnValue;
    this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {
      pulse.columnValues[columnId] = columnValue + '';
    });
  }
  // 编辑查看任务
  editTask(task) {
    this.selectedPulseId = task.pulseId;
    for (const pulse of this.boardPulseData) {
      if (pulse.id === this.selectedPulseId) {
        this.pulse = pulse;
        break;
      }
    }
    this.onMemberSearch('');
    this.selectedGroup = task.groupId;
    this.addPulseNameValue = task.title;
    this.addTaskData = task.columnValues;
    setTimeout(() => {
      this.tplModal = this.modalService.create({
        nzContent: this.modalTplContent,
        nzMaskClosable: false,
        nzTitle: null,
        nzFooter: this.tplFooter,
        nzWidth: '600px',
        nzWrapClassName: 'vertical-center-modal custom-modal',
      });
    }, 200);
  }
  getBoardUserData() {
    this.randomUserUrl = this.taskService.getBoardUser(this.boardData.id);
    const getRandomNameList = (searchKey: string) =>
      this.http
        .get(`${this.randomUserUrl}`, {params: {searchKey}})
        .pipe(map((res: any) => res.users ? res.users.data : []))
        .pipe(
          map((list: any) => {
            return list;
          })
        );
    const optionList$: Observable<any[]> = this.searchChange$
      .asObservable()
      .pipe(debounceTime(500))
      .pipe(switchMap(getRandomNameList));
    optionList$.subscribe(data => {
      this.personOption = data;
      this.isLoading = false;
    });
  }
  // 模糊搜索
  onMemberSearch(value: string): void {
    this.isLoading = true;
    this.searchChange$.next(value);
  }
  chooseUser(target, user) {
    if (!target || !target.personsAndTeams) {
      target = {
        personsAndTeams: []
      };
    }
    let existFlag = false;
    let index = -1;
    for (const person of target.personsAndTeams) {
      index++;
      if (person['id'] === user['id']) {
        existFlag = true;
        break;
      }
    }
    if (existFlag) {
      target.personsAndTeams.splice(index, 1);
    } else {
      target.personsAndTeams.push(user);
    }
  }
  removeUser(target, index) {
    target.splice(index, 1);
  }
  userSelected(target, user): boolean {
    if (target && target.personsAndTeams) {
      for (const person of target.personsAndTeams) {
        if (person.id === user.id) {
          return true;
        }
      }
    }
    return false;
  }
  // 更换状态标签
  clickStatus() {
    this.isEditVisual = true;
    this.statusWidth = this.statusInit.length / 4 * 122;
  }
  // 计算标签组件框宽度
  getStatusWidth(label) {
    const len = label ? label.length : 0;
    const width = 134;
    if (len > 4) {
      this.statusWidth = Number.isInteger(len / 4) ? len / 4 * width : Math.ceil(len / 4) * width;
    } else {
      this.statusWidth = width;
    }
    return {'width': this.statusWidth + 'px'};
  }
  // 切换选中状态颜色
  changeStatus(column, item) {
    let count = 0;
    let checked = 0;
    this.addTaskData[column.id] = item;
    // 进度条赋值
    this.boardColumnData.forEach((list) => {
      if (list.type === 'status') {
        count = count + 1;
        if (this.addTaskData[list.id] && this.addTaskData[list.id].index === 2) {
          checked = checked + 1;
        }
      }
    });
    if (checked) {
      this.addProgressValue = parseInt(((checked / count) * 100).toString(), 0);
    } else {
      this.addProgressValue = 0;
    }
    column['visible'] = false;
  }
  // 标签组件切换到编辑状态
  editStatus(column) {
    this.isEditVisual = !this.isEditVisual;
    this.getStatusWidth(this.statusInit);
    // 处理编辑状态选项
    this.statusTemp = column.labels;
    // 状态标签列表增加已用标签
    const tempList = [];
    this.boardPulseData.forEach((list) => {
      for (let k = 0; k < this.boardColumnData.length; k++) {
        if (this.boardColumnData[k].type === 'status') {
          tempList.push(list.columnValues[this.boardColumnData[k].id].index);
        }
      }
    });
    this.statusTemp.map((item, i) => {
      item.use = false;
      if (item.index === 0) {
        this.statusTemp.splice(i, 1);
      }
    });
    tempList.forEach((item) => {
      for (let i = 0; i < this.statusTemp.length; i++) {
        if (item === this.statusTemp[i].index) {
          this.statusTemp[i].use = true;
        }
      }
    });
    // 状态标签未选列表
    this.statusDel = this.statusInit.filter(obj => !this.statusTemp.some(obj1 => obj1.index === obj.index));
  }
  // 删除状态标签
  removeStatusTag(id) {
    this.statusTemp = this.statusTemp.filter(d => d.index !== id);
    this.statusInit.forEach((item, index) => {
      if (id === item.index) {
        this.statusDel.push(item);
      }
    });
  }
  // 添加状态标签
  addStatusTag() {
    const arr = this.statusInit.filter(obj => !this.statusTemp.some(obj1 => obj1.index === obj.index));
    if (arr.length > 0) {
      this.statusTemp = [
        ...this.statusTemp,
        {
          index: arr[0].index,
          label: '',
          color: arr[0].color
        }
      ];
      this.statusDel = this.statusDel.filter(d => d.color !== arr[0].color);
    }
  }
  // 添加自定义颜色标签
  addCustomTag(index) {
    const arr = this.statusInit.filter(obj => !this.statusTemp.some(obj1 => obj1.index === obj.index));
    if (arr.length > 0) {
      for (let i = 0; i < arr.length; i++) {
        if (index === arr[i].index) {
          this.statusTemp = [
            ...this.statusTemp,
            {
              index: arr[i].index,
              label: '',
              color: arr[i].color
            }
          ];
          this.statusDel = this.statusDel.filter(d => d.index !== arr[i].index);
        }
      }
    }
    this.addTabBGColor = '#F7F7F7';
  }
  // 鼠标移入移出添加标签背景变色
  mouseEnterStatus(color) {
    this.addTabBGColor = color;
  }
  mouseLeaveStatus() {
    this.addTabBGColor = '#F7F7F7';
  }
  // 标签组件提交编辑
  submitEditStatus(columnId, boardId) {
    const param = {
      'labels': this.statusTemp
    };
    this.defaultStatus[columnId] = this.statusTemp;
    this.taskService.doAddStatusLabel(boardId, columnId, param).subscribe(() => {
      this.boardColumnData.forEach((item) => {
        if (item.id === columnId) {
          item.labels = this.statusTemp;
        }
        let count = 0;
        if (item.type === 'status') {
          for (let i = 0; i < item.labels.length; i++) {
            if (item.labels[i].index === 0) {
              count = count + 1;
            }
          }
          if (count === 0) {
            if (item.type === 'status') {
              const o = {
                'color': 'rgb(196, 196, 196)',
                'index': 0,
                'label': ''
              };
              item.labels.push(o);
            }
          }
        }
      });
      this.isEditVisual = !this.isEditVisual;
    });
  }
  timeIntervalChange(columnId, value) {
    let date;
    if (value && value.length > 0) {
      date = {
        date: [this.datePipe.transform(value[0], 'yyyy-MM-dd HH:mm'), this.datePipe.transform(value[1], 'yyyy-MM-dd HH:mm')]
      };
    } else {
      date = {
        date: []
      };
    }
    this.addTaskData[columnId] = date;
    this.cellValueChange(columnId, date);
  }
  dateChange(columnId, value) {
    let date;
    if (value) {
      date = {
        date: this.datePipe.transform(value, 'yyyy-MM-dd')
      };
    } else {
      date = {};
    }
    this.cellValueChange(columnId, date);
  }
  cellValueChange(columnId, value) {
    const param = {
      pulseIds: [this.selectedPulseId],
      columnId: columnId,
      columnValue: value
    };
    this.taskService.doEditPulse(this.boardId, param).subscribe(() => {});
  }
  pulseNameChange(value) {
    this.taskService.doEditPulseName(this.selectedPulseId, {name: value}).subscribe(() => {});
  }
  tplModalSubmit() {
    if (this.dateColumn && JSON.stringify(this.dateColumn) !== '{}') {
      for (const item of this.calendarEvent) {
        if (item.pulseId === this.selectedPulseId) {
          item.columnValues = this.addTaskData;
          item.date = item['columnValues'][this.dateColumn['id']].date;
          break;
        }
      }
      this.getCalendarEvent();
      this.handleTask();
    }
    this.tplModal.destroy();
  }
  popCellValueChange(visible, columnId, value) {
    if (!visible) {
      this.cellValueChange(columnId, value);
    }
  }
  // 按钮组件-自定义按钮点击事件
  buttonCustomClick(column, pulse) {
    let url = '';
    column.config.original.forEach((item) => {
      if (item.id.toString() === pulse.columnValues[column.id].original.toString()) {
        url = item.url;
      }
    });
    const param = {
      'pulseId': pulse.id,
      'columnId': column.id
    };
    this.clickButtonLoading = true;
    this.taskService.buttonClickEvent(url, param).subscribe(() => {
      this.clickButtonLoading = false;
    }, () => {
      this.clickButtonLoading = false;
    });
  }
  // 按钮组件-按钮配置pop框
  openButtonConfig(pulseId, column) {
    this.buttonConfigStatus = true;
    // 设置无法删除标识
    const userIds = this.getButtonUserIds(column);
    if (column.config.original && column.config.original.length > 0) {
      column.config.original.forEach((item) => {
        item.notRemove = false;
        for (let i = 0; i < userIds.length; i++) {
          if (item.id === userIds[i]) {
            item.notRemove = true;
          }
        }
      });
    }
  }
  // 按钮组件-获取所有按钮已用ID
  getButtonUserIds(column) {
    let useIds = [];
    this.boardPulseData.forEach((pulses) => {
      for (const item in pulses.columnValues) {
        if (pulses.columnValues.hasOwnProperty(item)) {
          if (pulses.columnValues[column.id].original) {
            useIds.push(pulses.columnValues[column.id].original);
          }
        }
      }
    });
    useIds = Array.from(new Set(useIds));
    return useIds;
  }
  buttonSelectChange(event, pulseId, column) {
    const param = {};
    param['pulseIds'] = [pulseId];
    param['columnId'] = column.id;
    param['columnValue'] = {
      original: event
    };
    this.taskService.doEditPulse(this.boardId, param).subscribe(() => {});
  }

  // 按钮组件-编辑
  editButtonConfig(item) {
    this.buttonConfigEditData = item;
    this.buttonConfigStatus = !this.buttonConfigStatus;
    this.buttonConfigEditStatus = true;
    this.buttonConfigTitle = item.title;
    this.buttonConfigDisabled = item.usable;
    this.buttonConfigUrl = item.url;
  }

  // 按钮组件-删除
  removeButtonConfig(itemId, column) {
    column.config.original = column.config.original.filter(item => item.id !== itemId);
  }

  buttonConfigChange(event) {
    this.buttonConfigDisabled = event;
  }
  // 按钮配置新增/编辑事件
  buttonConfigAdd() {
    this.buttonConfigTitle = null;
    this.buttonConfigDisabled = true;
    this.buttonConfigUrl = null;
    this.buttonConfigStatus = !this.buttonConfigStatus;
    this.buttonConfigEditStatus = false;
  }

  // 按钮配置提交
  buttonConfigSubmit(type, column) {
    if (!this.buttonConfigTitle) {
      this.message.create('error', '请输入按钮名称');
    } else {
      if (type === 'add') {
        const maxId = this.getMaxId(column.config.original) + 1;
        const addObj = {
          'id': maxId,
          'title': this.buttonConfigTitle,
          'type': 'primary',
          'usable': this.buttonConfigDisabled,
          'url': this.buttonConfigUrl
        };
        column.config.original = [
          ...column.config.original,
          addObj
        ];
      } else if (type === 'edit') {
        column.config.original.forEach((item) => {
          if (item.id === this.buttonConfigEditData['id']) {
            item.title = this.buttonConfigTitle;
            item.usable = this.buttonConfigDisabled;
            item.url = this.buttonConfigUrl;
          }
        });
      }
      const param = {
        'config': column.config
      };
      this.taskService.doEditColumnHeader(this.boardId, column.id, param).subscribe(() => {});
      this.buttonConfigStatus = !this.buttonConfigStatus;
    }
  }
  // 获取按钮ID
  getMaxId(data) {
    const ids = [];
    if (data && data.length > 0) {
      data.forEach((item) => {
        ids.push(item.id);
      });
      return ids.reduce((a, b) => {
        return b > a ? b : a;
      });
    } else {
      return 0;
    }
  }
}
